
export enum ClaimCurrencyCd {
	CANADIAN_DOLLARS = 'CanadianDollars',
	US_DOLLARS = 'USDollars'}

